module.exports = __webpack_public_path__ + "img/cometh-prof.445f72c0.png";